import React, { Suspense, lazy, useEffect } from "react";
import ProjectDetails from "../components/ProjectDetails";
import Footer from "../components/Footer";
import Header from "../components/Header/Header.jsx";
import styled from "styled-components";
import { Helmet } from "react-helmet";

// Lazy load components
const Projects = lazy(() => import("../components/Projects"));

const ProjectsSection = styled.div`
  padding-top: 80px;
  background: linear-gradient(
    343.07deg,
    rgba(132, 59, 206, 0.06) 5.71%,
    rgba(132, 59, 206, 0) 60.83%
  );
  min-height: 100vh;
`;

function AllProjects({ firebaseData, openModal, setOpenModal }) {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Projects | Huynh Phuoc Tan Portfolio</title>
        <meta
          name="description"
          content="TanDev, Huynh Phuoc Tan, showcasing Web, Back-end Developer, Java and .NET projects."
        />
        <meta
          name="keywords"
          content="TanDev, Huynh Phuoc Tan, showcasing Web, Back-end Developer, Java and .NET projects."
        />
        <meta name="author" content="Sibi Siddharth S" />
        <link rel="canonical" href="https://github.com/Tanas-IT" />

        {/* Open Graph Data */}
        <meta
          property="og:title"
          content="TanDev -Huynh Phuoc TanPortfolio | Projects"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://github.com/Tanas-IT" />
      </Helmet>

      <Header Title="Projects Page" />
      <ProjectsSection>
        <Suspense>
          <Projects
            projectsData={firebaseData.projects || []}
            openModal={openModal}
            setOpenModal={setOpenModal}
            defaultfilter="all"
            projectFilters={["all", ".NET", "Java"]}
            ViewAllCard={0}
            ShowTitle={null}
            IntroText={1}
          />
        </Suspense>

        {openModal.state && (
          <ProjectDetails
            projectsData={firebaseData.projects || []}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        )}

        <Footer footerData={firebaseData.Bio || {}} />
      </ProjectsSection>
    </>
  );
}

export default AllProjects;
